import { SyntheticEvent } from "react";
import { get } from "lodash";

export const isEnter = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "Enter";
};

export const isSpace = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === " ";
};

export const isEscape = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "Escape";
};

export const isArrowUp = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "ArrowUp";
};

export const isArrowDown = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "ArrowDown";
};

export const isArrowLeft = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "ArrowLeft";
};

export const isArrowRight = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "ArrowRight";
};

export const handleEnter =
  (callback: (event: KeyboardEvent | SyntheticEvent) => void) =>
  (event: KeyboardEvent | SyntheticEvent) => {
    if (isEnter(event)) {
      callback(event);
    }
  };

export const handleEscape = (event: KeyboardEvent | SyntheticEvent, callback: () => void) => {
  if (isEscape(event)) {
    callback();
  }
};

export const isTargetInput = (event: KeyboardEvent): boolean => {
  const target = event.target instanceof HTMLElement ? event.target : null;
  return (
    target !== null &&
    (target.tagName === "INPUT" ||
      target.tagName === "TEXTAREA" ||
      target.tagName === "SELECT" ||
      target.closest("[contenteditable]") !== null)
  );
};

export const isPrintableKey = (e: KeyboardEvent | React.KeyboardEvent) =>
  e.key?.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
